// extracted by mini-css-extract-plugin
module.exports = {"navigationmain":"Navigations_navigationmain__3D8vc"};